import { useSyncExternalStore } from 'react';

const TICK_MS = 15_000;
const listeners = new Set<() => void>();
let timer: ReturnType<typeof setInterval> | undefined;

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  if (!timer) timer = setInterval(() => listeners.forEach((l) => l()), TICK_MS);
  return () => {
    listeners.delete(cb);
    if (listeners.size === 0 && timer) {
      clearInterval(timer);
      timer = undefined;
    }
  };
}

const bucket = () => Math.floor(Date.now() / TICK_MS);

/** Re-renders the caller every ~15 s (one shared timer) so relative times stay current. */
export function useNow(): number {
  useSyncExternalStore(subscribe, bucket, bucket);
  return Date.now();
}
